export const resolveCartUid = async ({
	currentUid,
	isFresh = false,
	loadCart,
	createCart
}) => {
	if (currentUid && !isFresh) {
		const existingCart = await loadCart(currentUid)
		if (existingCart) {
			return { uid: currentUid, stale: false, unavailable: false }
		}
		if (existingCart === null) {
			return { uid: null, stale: false, unavailable: true }
		}
	}

	const uid = await createCart()
	return {
		uid: uid || null,
		stale: Boolean(currentUid && !isFresh),
		unavailable: !uid
	}
}
